import { KeyboardArrowRightIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { ListItem } from "@l2r-front/l2r-ui"

import * as Styled from "./MobileAccountSettingsMenuItem.styled"

export const MobileAccountSettingsMenuItem = (props) => {
    const {
        label,
        desc,
        icon,
        onClick,
        variant,
        showArrow,
        ...listItemProps
    } = props

    const ContainerComponent = onClick ? Styled.ListItemButton : Styled.ListItemContainer

    return (
        <ContainerComponent {...listItemProps} onClick={onClick}>
            {icon && <Styled.IconWrapper>
                {icon}
            </Styled.IconWrapper>}
            <Styled.ListItem variant={variant}>
                <Styled.ListItemHeader>
                    <Styled.PrimaryTypography id="accountSettings-label" variant="Regular">
                        {label}
                    </Styled.PrimaryTypography>
                </Styled.ListItemHeader>
                {desc && <Styled.SecondaryTypography
                    id="accountSettings-desc"
                    variant="Small"
                    textColor={variant === "primary" ? "text/secondary" : "texts/text-placeholder"}>
                    {desc}
                </Styled.SecondaryTypography>}
            </Styled.ListItem>
            {showArrow && <KeyboardArrowRightIcon color="objects/object-black" />}
        </ContainerComponent >
    )
}

MobileAccountSettingsMenuItem.propTypes = {
    ...ListItem.propTypes,
    label: PropTypes.string.isRequired,
    desc: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(["primary", "secondary"]),
    showArrow: PropTypes.bool,
}

MobileAccountSettingsMenuItem.defaultProps = {
    variant: "primary",
    showArrow: true,
}